export const PATIENT_CONTACT_ERROR = {
  NO_PHONE_NUMBER: "No phone number available",
  NO_CALL_CONSENT: "Patient has not consented to phone calls",
  NO_EMAIL_ADDRESS: "No email address available",
  NO_EMAIL_CONSENT: "Patient has not consented to emails",
} as const;
